import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ThemeProvider } from '@material-ui/core/styles';

import { Theme } from '../theme';
import { Icons } from '../icons/icons';
import { StyledTextField } from '../mui/mui-textfield';

// Material-UI Pickers
import { TimePicker, KeyboardTimePicker } from '@material-ui/pickers';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import moment from 'moment';
import {
  LocalizedUtils,
  createPickerTheme,
  getPickerLanguage,
  getPickerLocale,
  setPickerMomentLocale
} from './mui-pickers.utils';

// TextField TimePicker
const MuiTextFieldTimePicker = ({ ...props }) => {
  return (
    <StyledTextField
      {...props}
      InputProps={{ endAdornment: (<Icons.Time />) }}
    />
  );
};

const materialTheme = createPickerTheme({
  MuiPickersToolbar: {
    toolbar: {
      height: '70px',
      backgroundColor: Theme.colors.blueDark,
      '& h2': {
        fontFamily: 'Bryant Pro Medium',
        fontSize: Theme.typography.heading2,
        fontWeight: 'normal',
        letterSpacing: 'normal',
        whiteSpace: 'normal',
      },
      '& h6': {
        fontFamily: 'Bryant Pro Medium',
        fontSize: Theme.typography.heading6,
        fontWeight: 'normal',
        letterSpacing: '0.0175em',
        whiteSpace: 'normal',
      },
    }
  }
});

const MuiTimePicker = (props) => {
  const lang = getPickerLanguage();
  const locale = getPickerLocale(lang);

  useEffect(() => {
    setPickerMomentLocale(lang);
  }, [lang]);

  const {
    allowKeyboard,
    ...restProps
  } = props;

  return (
    <ThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={LocalizedUtils} locale={locale} moment={moment}>
        {!allowKeyboard ? (
          <TimePicker
            {...restProps}
            autoOk
            variant="inline"
            mask="__:__ _M"
            TextFieldComponent={MuiTextFieldTimePicker}
          />
        ) : (
          <KeyboardTimePicker
            {...restProps}
            autoOk
            variant="inline"
            mask="__:__ _M"
            keyboardIcon={<Icons.Time />}
            TextFieldComponent={StyledTextField}
          />
        )}
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

MuiTimePicker.propTypes = {
  // Boolean to change TimePicker to KeyboardTimePicker.
  allowKeyboard: PropTypes.bool
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

/* KeyboardTimePicker Styles */
export const StyledTimePicker = styled(MuiTimePicker)`
  .MuiIconButton-root {
    padding: 8px;
    right: -8px;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;
